import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask1300To1399Service {

  constructor() { }
}
